export type DetectionSource = 'timezone' | 'default' | 'none';

export interface CountryConfig {
  countryCode: string;
  consentType: string;
  autoSelectCountry: boolean;
  autoSelectConsent: boolean;
  editableCountry: boolean;
  editableConsent: boolean;
}

export const ISO_TO_COUNTRY: Record<string, string> = {
  AT: 'Austria', BE: 'Belgium', BG: 'Bulgaria',
  HR: 'Croatia', CY: 'Cyprus', CZ: 'Czech Republic',
  DK: 'Denmark', EE: 'Estonia', FI: 'Finland',
  FR: 'France', DE: 'Germany', GR: 'Greece',
  HU: 'Hungary', IS: 'Iceland', IE: 'Ireland',
  IT: 'Italy', LV: 'Latvia', LI: 'Liechtenstein',
  LT: 'Lithuania', LU: 'Luxembourg', MT: 'Malta',
  NL: 'Netherlands', NO: 'Norway', PL: 'Poland',
  PT: 'Portugal', RO: 'Romania', SK: 'Slovakia',
  SI: 'Slovenia', ES: 'Spain', SE: 'Sweden',
  CH: 'Switzerland', GB: 'United Kingdom', US: 'United States',
  CA: 'Canada', BR: 'Brazil', IN: 'India',
  SG: 'Singapore', TH: 'Thailand', MY: 'Malaysia',
  PH: 'Philippines', ID: 'Indonesia', VN: 'Vietnam',
  JP: 'Japan', KR: 'South Korea', AU: 'Australia',
  NZ: 'New Zealand', HK: 'Hong Kong', TW: 'Taiwan',
  PK: 'Pakistan', BD: 'Bangladesh', AE: 'United Arab Emirates',
  SA: 'Saudi Arabia', BH: 'Bahrain', QA: 'Qatar',
  EG: 'Egypt', ZA: 'South Africa', NG: 'Nigeria',
  KE: 'Kenya', TR: 'Turkey', UA: 'Ukraine',
  IL: 'Israel', MX: 'Mexico', AR: 'Argentina',
  CO: 'Colombia', CL: 'Chile',
};

export const COUNTRY_CONFIGS: Record<string, Omit<CountryConfig, 'countryCode'>> = {
  CH: { consentType: 'SWITZERLAND', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  AT: { consentType: 'AUSTRIA', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  BE: { consentType: 'BELGIUM', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  DE: { consentType: 'GERMANY', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  FR: { consentType: 'FRANCE', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  IT: { consentType: 'ITALY', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  ES: { consentType: 'SPAIN', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  NL: { consentType: 'NETHERLANDS', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  PL: { consentType: 'POLAND', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  SE: { consentType: 'SWEDEN', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  NO: { consentType: 'NORWAY', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  DK: { consentType: 'DENMARK', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  FI: { consentType: 'FINLAND', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  GB: { consentType: 'UK', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  IE: { consentType: 'IRELAND', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  PT: { consentType: 'PORTUGAL', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  US: { consentType: 'USA', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  CA: { consentType: 'CANADA', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  BR: { consentType: 'BRAZIL', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  IN: { consentType: 'INDIA', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: true },
  AU: { consentType: 'AUSTRALIA', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  JP: { consentType: 'JAPAN', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  SG: { consentType: 'SINGAPORE', autoSelectCountry: true, autoSelectConsent: true, editableCountry: false, editableConsent: false },
  PK: { consentType: 'PAKISTAN', autoSelectCountry: true, autoSelectConsent: true, editableCountry: true, editableConsent: true },
  DEFAULT: { consentType: '', autoSelectCountry: false, autoSelectConsent: false, editableCountry: true, editableConsent: true },
};

